import React from 'react';
import { NumberInput } from '@mantine/core';
import { isEmptyTyped, isIncompleteNumber } from './typedNumber';
import { useDebouncedFieldValue } from './useDebouncedFieldValue';

const MIN_PERCENT = 0;
const MAX_PERCENT = 100;

const toPercent = (opacity) => (opacity == null ? MAX_PERCENT : Math.round(opacity * 100));
const clampPercent = (percent) => Math.min(MAX_PERCENT, Math.max(MIN_PERCENT, Number(percent)));
const toOpacity = (typed) => (isEmptyTyped(typed) ? undefined : clampPercent(typed) / 100);

/**
 * Opacité d'un bloc : saisie en % (comme le classique), stockée de 0 à 1 — la
 * valeur que le rendu pose telle quelle dans `opacity`. Vide = pas d'opacité
 * posée, donc pleinement opaque.
 */
export function OpacityInput({ value, onChange, label }) {
  const commit = (typed) => {
    if (!isIncompleteNumber(typed)) onChange(toOpacity(typed));
  };

  const {
    local, setLocal, change, focus, endFocus,
  } = useDebouncedFieldValue(value, commit, { toLocal: toPercent });

  return (
    <NumberInput
      size="xs"
      label={label}
      value={local}
      onFocus={focus}
      onBlur={() => {
        endFocus();
        // Traverser le champ ne doit rien écrire : sans opacité posée, il
        // affiche 100 %, qui s'écrirait `opacity: 1`.
        if (local !== toPercent(value) && toOpacity(local) !== value) commit(local);
        if (!isEmptyTyped(local) && !isIncompleteNumber(local)) setLocal(clampPercent(local));
      }}
      onChange={change}
      min={MIN_PERCENT}
      max={MAX_PERCENT}
      step={5}
      suffix=" %"
      clampBehavior="blur"
    />
  );
}

export function puckOpacityField(label = 'Opacité') {
  return {
    type: 'custom',
    label,
    render: ({ value, onChange }) => (
      <OpacityInput value={value} onChange={onChange} label={label} />
    ),
  };
}

export default puckOpacityField;
